import { greenMark } from "../../../../../../../../assets";
import { CurrencyValue, Typography } from "../../../../../../../../components";
import { config } from "../../../../../../../../config";
import { useMediaQuery } from "../../../../../../../../hooks";
import { device } from "../../../../../../../../style";
import { formatBigNumber } from "../../../../../../../../utils";
import { RewardToClaim } from "../useClaimAllRewardsHandler";
import * as S from "./RewardInfo.styled";

type RewardInfoProps = {
  reward: RewardToClaim;
};

export const RewardInfo = (props: RewardInfoProps) => {
  const {
    reward: {
      name,
      usdcRewards,
      soilRewards,
      isClaimPending,
      isClaimCompleted,
      type,
    },
  } = props;

  const isNotSmallMobile = useMediaQuery(device.mobileM);

  return (
    <S.Wrapper isPending={isClaimPending} isAvailable>
      <div>
        {isClaimCompleted && (
          <S.ClaimConfirm>
            Claimed <img src={greenMark} alt="green mark icon" />
          </S.ClaimConfirm>
        )}
        <Typography.Body fontWeight={700}>{name}</Typography.Body>
      </div>
      <div>
        <S.RewardsWrapper>
          {type === "POOL" && (
            <CurrencyValue
              isBig={isNotSmallMobile}
              value={formatBigNumber(usdcRewards, config.USDC_TOKEN_DECIMALS)}
              currency={config.STABLE_TOKEN}
              decimals={2}
            />
          )}
          <CurrencyValue
            isBig={isNotSmallMobile}
            value={formatBigNumber(soilRewards, config.SOIL_TOKEN_DECIMALS)}
            currency={config.PROJECT_TOKEN}
            decimals={2}
          />
        </S.RewardsWrapper>
      </div>
      {isClaimPending && <S.Spinner />}
    </S.Wrapper>
  );
};
